/**
 * Patient Context Bar Feature
 *
 * Self-contained feature for displaying patient context information
 * including medications, diagnoses, allergies, and last encounter.
 */

import { autoRegisterFeature } from '@store/features/factory';

import { patientContextBar } from './store/feature';

// Auto-register the feature
autoRegisterFeature(patientContextBar);

// Export everything
export * from './components';
export * from './hooks';
export * from './store';
export * from './types';

